import React from 'react'

const ProjectSettingController = ({ children }) => {
  return (
    <>{children}</>
  )
}

export default ProjectSettingController